import { render, staticRenderFns } from "./ExpenseProcessed.vue?vue&type=template&id=210ac0f3&scoped=true&"
import script from "./ExpenseProcessed.vue?vue&type=script&lang=js&"
export * from "./ExpenseProcessed.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseProcessed.vue?vue&type=style&index=0&id=210ac0f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210ac0f3",
  null
  
)

export default component.exports